//CATEGORY
export const CATEGORY_HEADER = 'Header'
export const CATEGORY_TOP_MENU = 'Top Menu'
export const CATEGORY_HOMEPAGE = 'Homepage'
export const CATEGORY_FOOTER = 'Footer'
export const CATEGORY_REGISTER_WITH_PROMOTION_CODE = 'Register with promotion code'
export const CATEGORY_CONTACT_HRTABLE = 'Contact HR Table'
export const CATEGORY_MONEYTABLE = 'MoneyTable'
export const CATEGORY_HRTABLE = 'HR Table'
export const CATEGORY_ABOUT_US_WHO_ARE_WE = 'About Us-Who are we?'
export const CATEGORY_ABOUT_US_WHAT_WE_DO = 'About Us-What we do?'
export const CATEGORY_ABOUT_US_OUR_VERSION = 'About Us-Our version'
export const CATEGORY_ABOUT_US_OUR_MISSION = 'About Us-Our mission'
export const CATEGORY_ABOUT_US_CORE_VALUE = 'About Us-Core value'
export const CATEGORY_ABOUT_US_OUR_TEAM = 'About Us-Our Team'
export const CATEGORY_ABOUT_US_JOIN_OUR_TEAM = 'About Us-Join our team'
export const CATEGORY_ABOUT_US = 'About Us'
export const CATEGORY_CAREER = 'Career'
export const CATEGORY_BLOG = 'Blog'
export const CATEGORY_OUR_ACTIVITY = 'Our Activity'
export const CATEGORY_CONTACT_US = 'Contact Us'
export const CATEGORY_GOTO_TOP = 'Go to top'
export const CATEGORY_NEWS = 'News'
export const CATEGORY_DAYCASH = 'DayCash'
//ACTION
export const ACTION_INFORMATION = 'Ask More Information'
export const ACTION_FACEBOOK = 'Facebook'
export const ACTION_INSTAGRAM = 'Instagram'
export const ACTION_YOUTUBE = 'Youtube'
export const ACTION_LINKEDIN = 'Linked in'
export const ACTION_REGISTER = 'Register with promotion code'
export const ACTION_TH = 'TH'
export const ACTION_EN = 'EN'
export const ACTION_MONEYTABLE = 'MoneyTable'
export const ACTION_OUR_PRODUCT = 'Our Product'
export const ACTION_OP_MONEYTABLE = 'Our Product-MoneyTable'
export const ACTION_OP_HRTABLE = 'Our Product-HrTable'
export const ACTION_ABOUT_US = 'About Us'
export const ACTION_AU_WHO_ARE_WE = 'About Us-Who are we?'
export const ACTION_AU_WHAT_WE_DO = 'About Us-What we do?'
export const ACTION_AU_OUR_VISION = 'About Us-Our vision'
export const ACTION_AU_OUR_MISSION = 'About Us-Our mission'
export const ACTION_AU_CORE_VALUE = 'About Us-Core value'
export const ACTION_AU_OUR_TEAM = 'About Us-Our Team'
export const ACTION_AU_JOIN_OUR_TEAM = 'About Us-Join our team'
export const ACTION_AU_TERM_CONDITION = 'About Us-Term & Condition'
export const ACTION_AU_PRIVACY = 'About Us-Privacy'
export const ACTION_BLOG = 'Blog'
export const ACTION_OUR_ACTIVITY = 'Activity'
export const ACTION_CONTACT_US = 'Contact Us'
export const ACTION_MONEYTABLE_PRODUCT = 'MoneyTable Product'
export const ACTION_HRTABLE_PRODUCT = 'HRTable Product'
export const ACTION_NEWS_UPDATE = 'News Update'
export const ACTION_NEWS_UPDATE_MORE = 'News Update-more'
export const ACTION_HR_NEWS = 'HR News'
export const ACTION_HR_NEWS_MORE = 'HR News-more'
export const ACTION_HR_NEWS_DIGITAL_WORKPLACE = 'HR News-Digital Workplace'
export const ACTION_HR_NEWS_DIGITAL_HR_PLATFORM = 'HR News-Digital HR Platform'
export const ACTION_FINANCIAL_NEWS = 'Financial News'
export const ACTION_FINANCIAL_NEWS_MORE = 'Financial News-more'
export const ACTION_REVIEW_VIDEO = 'Review Video'
export const ACTION_CONTACT_US_LINE = 'Contact Us-Line'
export const ACTION_CONTACT_US_EMAIL = 'Contact Us-Email'
export const ACTION_HOME = 'Home'
export const ACTION_BLOGS_HR_ANSWER = 'Blogs-HR Answer'
export const ACTION_BLOGS_NEWS = 'Blogs-News'
export const ACTION_BLOGS_TIPS = 'Blogs-Tips'
export const ACTION_BLOGS_FINANCIAL = 'Blogs-Financial'
export const ACTION_BLOGS_VOCABULARY = 'Blogs-Vocabulary'
export const ACTION_CU_FILL_FORM = 'Contact Us-Fill Form (other question)'
export const ACTION_CU_REQUEST_HRTABLE = 'Contact Us-Request for HRTable Demo'
export const ACTION_CU_REQUEST_MONEYTABLE = 'Contact Us-Request for MoneyTable Demo'
export const ACTION_PARTNERS_ASSOCIATIONAL = 'Partners-Association'
export const ACTION_PARTNERS_FINANCIAL = 'Partners-Financial'
export const ACTION_PARTNERS_SOFTWARE = 'Partners-Software'
export const ACTION_PARTNERS_INSURANCE = 'Partners-Insurance'
export const ACTION_GO_TO_HRTABLE = 'Go to HR Table'
export const ACTION_REQUEST_PROMOTION_CODE = 'Request a promotional code'
export const ACTION_HAVE_PROMOTION_CODE = 'I already have a promo code'
export const ACTION_MICROSOFT_OFFICE_YES = 'Microsoft Office 365 Customer-Yes'
export const ACTION_MICROSOFT_OFFICE_NO = 'Microsoft Office 365 Customer-No'
export const ACTION_SEND = 'Send'
export const ACTION_REQUEST_DEMO = 'Request a Demo Today'
export const ACTION_LOG_IN = 'Log in'
export const ACTION_LEARN_MORE = 'Learn More'
export const ACTION_CONTACT_US_REGISTER = 'Contact Us to Register'
export const ACTION_MODAL_HRPLUS_VIEW_DETAIL = 'Modal HR Plus-View Detail'
export const ACTION_MODAL_HRPLUS_CLOSE = 'Modal HR Plus-Close'
export const ACTION_HRPLUS_VIEW_DETAIL = 'HR Plus-View Detail'
export const ACTION_HRPLUS_CLOSE = 'HR Plus-Close'
export const ACTION_PACKAGE_EMAIL = 'Package-Email'
export const ACTION_PACKAGE_INTEREST = 'Package-Interest'
export const ACTION_HRPLUS_CONTACT_US_SEND = 'HR Plus Contact Us-Send'
export const ACTION_DOWNLOAD_APP_STORE = 'Download on the App Store'
export const ACTION_DOWNLOAD_GOOGLE_PLAY = 'Android App on Google play'
export const ACTION_FEATURE_REQUEST_DEMO = 'Features-Request a Demo Today'
export const ACTION_EMPLOYEE_REQUEST_DEMO = 'Employee Database&Records-Request a Demo'
export const ACTION_COMPANY_REQUEST_DEMO = 'Company Announcement-Request a Demo'
export const ACTION_CLOKING_REQUEST_DEMO = 'Clocking-Request a Demo Today'
export const ACTION_REFERRALS_REQUEST_DEMO = 'Employee Referrals-Request a Demo'
export const ACTION_VIEW_INTRODUCTION = 'View Introduction Video'
export const ACTION_SEND_US_AN_EMAIL = 'Send us an email'
export const ACTION_FULL_STACK_DEV_APPLY = 'Full Stack Developer-Apply'
export const ACTION_CONTENT_MARKETING_MANAGER_APPLY = 'Content Marketing Manager-Apply'
export const ACTION_COMMUNITY_MARKETING_MANAGER_APPLY = 'Community Marketing Manager-Apply'
export const ACTION_PR_MANAGER_APPLY = 'PR Manager-Apply'
export const ACTION_BUSINESS_DEV_EXEC_APPLY = 'Business Development Executive-Apply'
export const ACTION_QA_OFFICER_APPLY = 'QA Officer-Apply'
export const ACTION_PROJECT_MANAGER_APPLY = 'Project Manager-Apply'
export const ACTION_COPY_WRITER_APPLY = 'Copy Writer-Apply'
export const ACTION_ALL = 'All'
export const ACTION_ALL_LIST = 'All-list'
export const ACTION_NEWS = 'News'
export const ACTION_NEWS_LIST = 'News-list'
export const ACTION_FINANCIAL = 'Financial'
export const ACTION_FINANCIAL_LIST = 'Financial-list'
export const ACTION_TIPS = 'Tips'
export const ACTION_TIPS_LIST = 'Tips-list'
export const ACTION_HR_TIPS = 'HR Tips'
export const ACTION_HR_TIPS_LIST = 'HR Tips-list'
export const ACTION_HR_ANSWER = 'HR Answers'
export const ACTION_HR_ANSWER_LIST = 'HR Answers-list'
export const ACTION_UNCATEGORIZED = 'Uncategorized'
export const ACTION_ACTIVITY = 'Activity'
export const ACTION_ACTIVITY_LIST = 'ACtivity-list'
export const ACTION_BLOG_LIST = 'Blog List'
export const ACTION_OUR_ACTIVITY_LIST = 'Our Activity List'
export const ACTION_GO_TO_TOP = 'Go to Top'
export const ACTION_TOP_MENU = 'From Top Menu'
export const ACTION_FOOTER = 'From Footer'
export const ACTION_HOMEPAGE = 'From Homepage'
export const ACTION_HRTABLE = 'HR Table'
export const DOWNLOAD_BROCHURE = 'DOWNLOAD BROCHURE HRT'
export const SEND_FROM_HRT_PRODUCT = 'Send Contact from HRT in Page'
export const ACTION_REGISTER_BANNER = "Register MS Event"
export const ACTION_SEND_INPAGE = 'Send from product page'
export const ACTION_HRPLUS_CONTACT_US_SEND_PACKAGE = 'Send from package page'
export const ACTION_OP_DAYCASH = 'Our Product-DayCash'


// WEBPACK FOOTER //
// ./src/ga/constant.js